<template>
    <div class="settings">
        <v-card flat="flat" class="nuclear">
            <v-card-title class="nuclear-title">Accept Invitation</v-card-title>
            <v-card-text class="nuclear-content">
                <span>{{this.status}}</span>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    mounted() {
        const params = this.$route.query;
        if (params.request != undefined) {
            this.status = "Accepting.."
            const data = {
                uuid: params.request
            };
            this.$store.dispatch("invite_accept", data).then(response => {
                this.status = response.data.status;
            }).catch(response => {
                this.status = response.data.status;
            });
        }
    },
    data() {
        return {
            status: ''
        }
    }
}
</script>